module.exports = {"id":"dp3_2l1q4","text":"Integrating and re-elaborating digital content","instructions":"When using generative AI to adapt digital content, what practice supports transparency?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.2","questionType":"PickOne","random":true,"options":[{"id":"dp3_2l1q4-a1","text":"Disclosing that AI assisted the content changes","score":1.8},{"id":"dp3_2l1q4-a2","text":"Removing all references to original sources","score":0},{"id":"dp3_2l1q4-a3","text":"Assuming AI outputs need no attribution","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.2/l1q4.json
// module id = 1133
// module chunks = 41